import React from 'react'
import Socials from '../shared/socials';
import './footer.css';

const footer = () => {
    return (
        <footer>
            <a href="/#" className='footer__logo'>Bhuwan Portfolio</a>
            <ul className="footer__links">
                <li><a href="/#">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#experience">Experience</a></li>
                <li><a href="#testimonials">Trainings</a></li>
                <li><a href="#services">Service</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>

            <Socials classToApply={"footer__socials"} />

            <div className="footer__copyright">
                <h6>No rights reserved, <a href="#contact"><span style={{ color: "red" }}>Contact Me For Code</span></a></h6>
            </div>
        </footer>
    )
}

export default footer